import { getAccreditationCount } from './../http'

const isTrue = x => !!x
export const every = xs => xs.every(isTrue)
export const some = xs => xs.some(isTrue)

export function modulesRequired(requiredModulesNames, predicate = every) {
  return function (event) {
    const requiredModules = requiredModulesNames.map(
      requiredModuleName => !!event.extraModules[requiredModuleName],
    )

    return predicate(requiredModules)
  }
}

export function allowedUserType(types) {
  return user => types.map(type => type.toLowerCase()).includes(user.type.toLowerCase())
}

export function isVerifiedByCoreEvent() {
  return user => user.isVerifiedByCoreEvent
}

export function accreditationLimitIfTrial(accreditationLimit = 20) {
  return async function (event, userType) {
    if (userType.toLowerCase() !== 'trial') return true
    const { accreditationCount } = await getAccreditationCount(event.id)

    return accreditationCount < accreditationLimit
  }
}

export function eventQuota() {
  return ({ eventQuota }) => eventQuota > 0
}
